import { PACKAGE_VERSION } from './version.js';

export const APP_NAME = 'AngkasMessenger/' + (PACKAGE_VERSION || process.env.REACT_APP_VERSION || '0.21');

export const API_KEY = process.env.REACT_APP_API_KEY;

export const KNOWN_HOSTS = {
  hosted: process.env.REACT_APP_KNOWN_HOSTS_HOSTED,
  local: process.env.REACT_APP_KNOWN_HOSTS_LOCAL
};

export const DEFAULT_HOST = KNOWN_HOSTS[process.env.REACT_APP_DEFAULT_HOST_TYPE];

export const LOGGING_ENABLED = process.env.REACT_APP_LOGGING_ENABLED === 'true';

/** Admin portal origin (scheme+host+port): trusted postMessage source and messenger:ready targetOrigin. */
export const ADMIN_PORTAL_PARENT_ORIGIN =
  (process.env.REACT_APP_ADMIN_PORTAL_PARENT_ORIGIN || '').trim() || undefined;

/** When embedded, require event.source === window.parent for auth token messages. */
export const ADMIN_PORTAL_REQUIRE_POSTMESSAGE_PARENT_SOURCE = true;

export const KEYPRESS_DELAY = parseInt(process.env.REACT_APP_KEYPRESS_DELAY || '3000', 10);
export const READ_DELAY = parseInt(process.env.REACT_APP_READ_DELAY || '1500', 10);

export const MIN_TAG_LENGTH = parseInt(process.env.REACT_APP_MIN_TAG_LENGTH || '2', 10);
export const MAX_TAG_LENGTH = parseInt(process.env.REACT_APP_MAX_TAG_LENGTH || '96', 10);
export const MAX_TAG_COUNT = parseInt(process.env.REACT_APP_MAX_TAG_COUNT || '16', 10);

export const DEFAULT_P2P_ACCESS_MODE = process.env.REACT_APP_DEFAULT_P2P_ACCESS_MODE;
export const NEW_GRP_ACCESS_MODE = process.env.REACT_APP_NEW_GRP_ACCESS_MODE;
export const CHANNEL_ACCESS_MODE = process.env.REACT_APP_CHANNEL_ACCESS_MODE;
export const NO_ACCESS_MODE = process.env.REACT_APP_NO_ACCESS_MODE;

export const MEDIA_BREAKPOINT = parseInt(process.env.REACT_APP_MEDIA_BREAKPOINT || '640', 10);
export const REM_SIZE = parseInt(process.env.REACT_APP_REM_SIZE || '13', 10);
export const AVATAR_SIZE = parseInt(process.env.REACT_APP_AVATAR_SIZE || '384', 10);
export const MAX_AVATAR_BYTES = parseInt(process.env.REACT_APP_MAX_AVATAR_BYTES || '4096', 10);
export const BROKEN_IMAGE_SIZE = parseInt(process.env.REACT_APP_BROKEN_IMAGE_SIZE || '32', 10);
export const NO_DIMENSIONS_VIDEO = parseInt(process.env.REACT_APP_NO_DIMENSIONS_VIDEO || '128', 10);

export const MESSAGES_PAGE = parseInt(process.env.REACT_APP_MESSAGES_PAGE || '24', 10);
export const MAX_INBAND_ATTACHMENT_SIZE = parseInt(process.env.REACT_APP_MAX_INBAND_ATTACHMENT_SIZE || '262144', 10);
export const MAX_EXTERN_ATTACHMENT_SIZE = parseInt(process.env.REACT_APP_MAX_EXTERN_ATTACHMENT_SIZE || (1 << 23), 10);
export const FORCE_EXTERN_MEDIA_UPLOAD = "true";

export const MAX_IMAGE_DIM = parseInt(process.env.REACT_APP_MAX_IMAGE_DIM || '1024', 10);
export const IMAGE_PREVIEW_DIM = parseInt(process.env.REACT_APP_IMAGE_PREVIEW_DIM || '64', 10);
export const VIDEO_PREVIEW_DIM = parseInt(process.env.REACT_APP_VIDEO_PREVIEW_DIM || '96', 10);
export const IMAGE_THUMBNAIL_DIM = parseInt(process.env.REACT_APP_IMAGE_THUMBNAIL_DIM || '36', 10);
export const VIDEO_THUMBNAIL_WIDTH = parseInt(process.env.REACT_APP_VIDEO_THUMBNAIL_WIDTH || '48', 10);

export const MAX_ONLINE_IN_TOPIC = parseInt(process.env.REACT_APP_MAX_ONLINE_IN_TOPIC || '4', 10);
export const MAX_TITLE_LENGTH = parseInt(process.env.REACT_APP_MAX_TITLE_LENGTH || '60', 10);
export const MAX_TOPIC_DESCRIPTION_LENGTH = parseInt(process.env.REACT_APP_MAX_TOPIC_DESCRIPTION_LENGTH || '360', 10);
export const MAX_PEER_TITLE_LENGTH = parseInt(process.env.REACT_APP_MAX_PEER_TITLE_LENGTH || '20', 10);

export const MAX_MESSAGE_LENGTH = parseInt(process.env.REACT_APP_MAX_MESSAGE_LENGTH || '3000', 10);
export const MESSAGE_PREVIEW_LENGTH = parseInt(process.env.REACT_APP_MESSAGE_PREVIEW_LENGTH || '80', 10);
export const QUOTED_REPLY_LENGTH = parseInt(process.env.REACT_APP_QUOTED_REPLY_LENGTH || '30', 10);
export const FORWARDED_PREVIEW_LENGTH = parseInt(process.env.REACT_APP_FORWARDED_PREVIEW_LENGTH || '84', 10);
export const EDIT_PREVIEW_LENGTH = parseInt(process.env.REACT_APP_EDIT_PREVIEW_LENGTH || '48', 10);

export const MIN_DURATION = parseInt(process.env.REACT_APP_MIN_DURATION || '2000', 10);
export const MAX_DURATION = parseInt(process.env.REACT_APP_MAX_DURATION || '600000', 10);

export const LINK_CONTACT_US = process.env.REACT_APP_LINK_CONTACT_US;
export const LINK_PRIVACY_POLICY = process.env.REACT_APP_LINK_PRIVACY_POLICY;
export const LINK_TERMS_OF_SERVICE = process.env.REACT_APP_LINK_TERMS_OF_SERVICE;
export const LINK_CLICK_TO_TALK = process.env.REACT_APP_LINK_CLICK_TO_TALK ||
  'https://www.angkas.com/contact';

export const IMMEDIATE_P2P_SUBSCRIPTION = process.env.REACT_APP_IMMEDIATE_P2P_SUBSCRIPTION === 'true';
export const CLICKABLE_URL_SCHEMES = (process.env.REACT_APP_CLICKABLE_URL_SCHEMES || 'http,https,ftp,ftps').split(',');

export const QRCODE_SIZE = parseInt(process.env.REACT_APP_QRCODE_SIZE || '128', 10);
export const WAKE_UP_TIMEOUT = parseInt(process.env.REACT_APP_WAKE_UP_TIMEOUT || '80000', 10);
export const WAKE_UP_TICK = parseInt(process.env.REACT_APP_WAKE_UP_TICK || '1000', 10);
export const AUTH_TIMEOUT = parseInt(process.env.REACT_APP_AUTH_TIMEOUT || '30000', 10);
export const DISCONNECT_GRACE_MS = parseInt(process.env.REACT_APP_DISCONNECT_GRACE_MS || '10000', 10);

let env = 'production';
try {
  env = process.env.REACT_APP_ENVIRONMENT || 'production';
} catch (e) {
  console.log('Error getting environment', e);
}
export const ENVIRONMENT = env;

// NSFW Content Moderation Configuration
export const NSFW_CHECK_ENABLED = process.env.REACT_APP_NSFW_CHECK_ENABLED === 'true';
export const NSFW_THRESHOLD = parseFloat(process.env.REACT_APP_NSFW_THRESHOLD || '0.2');
export const NSFW_FAIL_OPEN = process.env.REACT_APP_NSFW_FAIL_OPEN === 'true';

// Supported image MIME types and corresponding file extensions (output from canvas after processing).
export const SUPPORTED_IMAGE_FORMATS = process.env.REACT_APP_SUPPORTED_IMAGE_FORMATS.split(',');
export const MIME_EXTENSIONS = process.env.REACT_APP_MIME_EXTENSIONS.split(',');
export const HEIC_INPUT_MIMES = process.env.REACT_APP_HEIC_INPUT_MIMES.split(',');

// Feature flags for image transfer. Default to false when unset.
export const IMAGE_UPLOAD_ENABLED = process.env.REACT_APP_IMAGE_UPLOAD === 'true';
export const IMAGE_DOWNLOAD_ENABLED = process.env.REACT_APP_IMAGE_DOWNLOAD === 'true';
